import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/**
 * Generic legal/markdown-style page wrapper.
 */
export default function LegalPage({ title, description, children, testid }) {
  return (
    <div data-testid={testid} className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-14">
      <Helmet>
        <title>{`${title} | HostMarket`}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Link to="/" className="text-xs text-zinc-500 hover:text-[#FFBE00] uppercase tracking-wider">← Home</Link>
      <h1 className="font-heading font-black text-4xl sm:text-5xl mt-4 mb-4">{title}</h1>
      <p className="text-zinc-500 text-sm mb-8">Ultimo aggiornamento: 24 aprile 2026</p>
      <div className="prose prose-invert max-w-none text-zinc-300 leading-relaxed space-y-5 [&_h2]:font-heading [&_h2]:font-black [&_h2]:text-xl [&_h2]:text-white [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-bold [&_h3]:text-lg [&_h3]:text-white [&_h3]:mt-6 [&_h3]:mb-2 [&_a]:text-[#FFBE00] [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_strong]:text-white">
        {children}
      </div>
    </div>
  );
}
